import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import './Facilities.css';
import hitakrilogo from '../../assets/img/hitakrilogo.png';

// --- Import your facility images here ---
// Create a folder 'src/assets/img/facilities/' and add these images.
import ccuImage from './laboratry.png';
import sonographyImage from './sonography.JPG';
import scanningImage from '../../assets/img/features/feature-01.jpg';
import dialysisImage from '../../assets/img/specialities/8.png';
import healthCheckupImage from './ob-gyn.png';
import modularOtImage from '../../assets/img/specialities/1.png';
import emergencyImage from './emergencyImage.JPG';
import pharmacyImage from './pharmacy.png';
import ctscan from './CTScan.JPG'
import xray from './xray.JPG'
// --- Data for all facilities with ICONS ---
const facilitiesData = [
    {
       title: "CT Scan",
icon: "fa-solid fa-x-ray",
heading: "Advanced CT Scan",
description: "Our advanced CT (Computed Tomography) scanning services provide highly detailed, cross-sectional images of the body, enabling accurate diagnosis across a wide range of conditions. Using the latest in multi-slice CT technology, we can capture precise images of bones, blood vessels, and soft tissues in a single, quick scan. Whether for emergency evaluations, cancer detection, cardiovascular analysis, or routine health screenings, our scans are interpreted by board-certified radiologists who ensure accuracy and clarity. We also prioritize patient safety by utilizing low-dose imaging techniques without compromising image quality. With a focus on comfort, efficiency, and clinical excellence, our CT services support timely and confident medical decision-making.",
image: ctscan,

    },
    {
        title: "laboratory/CCU",
        icon: "fa-solid fa-heart-pulse",
        heading: "State-of-the-Art laboratory & Critical Care Units",
        description: "Our hospital features advanced laboratory, CCU, ICU, and NICU departments. The laboratory utilizes cutting-edge imaging for precise cardiovascular diagnostics, while our Critical Care Units (CCU/ICU) provide 24/7 intensive monitoring and life-support. The specialized Neonatal ICU (NICU) ensures the highest level of care for our smallest patients.",
        image: ccuImage,
    },
     {
        title: "Sonography",
        icon: "fa-solid fa-wave-square",
        heading: "Advanced Sonography (3D/4D) & 2D ECHO",
        description: "Experience unparalleled clarity with our state-of-the-art sonography services. Our 3D/4D imaging offers expecting parents a detailed, intimate view of their baby's development. The 2D ECHO provides a comprehensive evaluation of cardiac structure and function, crucial for diagnosing and managing heart conditions with precision and care.",
        image: sonographyImage,
    },
    {
    title: "X-ray",
    icon: "fa-solid fa-x-ray",
    heading: "State-of-the-Art X-ray & Diagnostic Imaging",
    description: "Our X-ray and diagnostic imaging services use the latest technology to provide fast, accurate results. With high-quality imaging, we help diagnose a wide range of conditions, from fractures to soft tissue issues, supporting your healthcare team in delivering precise treatment. Available for both emergency and routine assessments, our imaging services ensure quick and reliable diagnostics.",
    image: xray,
},
 {
        title: "OT",
        icon: "fa-solid fa-truck-medical",
        heading: "Operation Theatre (OT)",
        description: "An Operation Theatre (OT) is a specialized medical facility where surgical procedures are performed under sterile conditions. It is equipped with advanced medical equipment, lighting, and tools necessary for surgeries. The OT is designed to maintain a sterile environment to minimize the risk of infection and ensure patient safety during operations.",
        image: emergencyImage,
    },
   {
     title: "OB-GYN",
    icon: "fa-solid fa-user-md",
    heading: "Department of Obstetrics and Gynecology",
    description: "OB-GYN, short for Obstetrics and Gynecology, is a specialized medical field focused on women's reproductive health, pregnancy, and childbirth. In a hospital setting, OB-GYN departments provide comprehensive care, including prenatal checkups, labor and delivery services, surgical procedures like cesarean sections, and treatment of reproductive system disorders. The team typically includes obstetricians, gynecologists, nurses, and support staff working together to ensure the health and well-being of women at all stages of life.",
      image: healthCheckupImage,
    },
    
    {
        title: "Pharmacy",
        icon: "fa-solid fa-pills",
        heading: "24/7 In-House Pharmacy",
        description: "Our 24/7 in-house pharmacy ensures that patients have continuous access to essential medications. This vital service supports our commitment to comprehensive healthcare, providing convenience and peace of mind by maintaining a well-stocked inventory for all your medical needs, day or night.",
        image: pharmacyImage,
    },
      
    
];

const Facilities = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleTabClick = (index) => {
        if (index === activeIndex) return;

        setIsLoading(true);
        // Wait for the fade-out animation to complete before changing the content
        setTimeout(() => {
            setActiveIndex(index);
            setIsLoading(false);
        }, 300); // This duration should match the CSS animation duration
    };

    const activeFacility = facilitiesData[activeIndex];

    return (
        <>
            <div className="main-wrapper">
                <header className="header">
                    <Navbar />
                </header>
              

                <section className="facilities-section-enhanced">
                    <div className="container">
                        <div className="tabs-list-container-enhanced">
                            {facilitiesData.map((facility, index) => (
                                <div
                                    key={index}
                                    className={`facility-tab-enhanced ${index === activeIndex ? 'active' : ''}`}
                                    onClick={() => handleTabClick(index)}
                                >
                                    <div className="tab-icon-enhanced">
                                        <i className={facility.icon}></i>
                                    </div>
                                    <div className="tab-title-enhanced">{facility.title}</div>
                                </div>
                            ))}
                        </div>

                        <div className={`facility-content-display-enhanced ${isLoading ? 'content-loading' : ''}`}>
                            <div className="content-text-enhanced">
                                <h2>{activeFacility.heading}</h2>
                                <p>{activeFacility.description}</p>
                            </div>
                            <div className="content-image-enhanced">
                                <img src={activeFacility.image} alt={activeFacility.heading} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
            <footer className="footer">
                {/* Your existing footer code remains unchanged */}
                 <div className="footer-top">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-widget footer-about">
                                    <div className="footer-logo">
                                        <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                    </div>
                                    <div className="footer-about-content">
                                        <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                        <div className="social-icon">
                                            <ul>
                                                <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                                <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-menu">
                              <h2 className="footer-title">For Patients</h2>
                              <ul>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                  <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                  <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                  <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                          <div className="footer-widget footer-menu">
                              <h2 className="footer-title"
                              >
                                  For Patients
                              </h2>
                              <ul>
                                  <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                  <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                  <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                  <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                  <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                              </ul>
                          </div>
                      </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-widget footer-contact">
                                    <h2 className="footer-title">Contact Us</h2>
                                    <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                  <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                      <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                          <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                                              <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                              <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                              <span>PIN – 344022</span>
                                          </div>
                                      </a>
                                  </div>
                                  <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                      <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                          <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                          02988-223100
                                      </a>
                                  </p>
                                  <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                      <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                          <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                          hitkarihospitalblt2015@gmail.com
                                      </a>
                                  </p>
                              </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container-fluid">
                        <div className="copyright">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="copyright-text">
                                        <p className="mb-0">
                                            <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="copyright-menu">
                                        <ul className="policy-menu">
                                            <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight: '132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Facilities;